<script setup lang="ts">
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/24/outline';
import useTable from '@/modules/settings/composables/useTable';
import useTeams from '@/modules/settings/composables/useTeams';

const { asc, typeOrder, selectedItems, selectAll, indeterminate, orderBy } = useTable();
const { teams } = useTeams();

const all = () => teams.value.map((p) => p.id);
</script>

<template>
    <thead>
        <tr class="bg-gray-50">
            <th scope="col" class="relative px-7 sm:w-12 sm:px-6 rounded-t-md">
                <input
                    id="check_first"
                    type="checkbox"
                    class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded-sm border-gray-300 text-indigo-500 focus:ring-indigo-500"
                    :checked="indeterminate(teams.length) || selectedItems.length === teams.length"
                    :indeterminate="indeterminate(teams.length)"
                    @change="selectAll($event, all())"
                />
            </th>
            <th scope="col" class="w-2/4 py-3.5 pr-3 text-left text-sm font-semibold text-gray-900" @click="orderBy('name')">
                <div class="flex items-center cursor-pointer group">
                    Name
                    <span
                        class="ml-2 flex-none rounded-sm"
                        :class="[typeOrder === 'name' ? 'bg-gray-100 text-gray-900 hover:bg-gray-200 p-0.5' : 'invisible text-gray-400 group-hover:visible group-focus:visible']"
                    >
                        <ChevronDownIcon v-if="asc" class="h-4 w-4" aria-hidden="true" />
                        <ChevronUpIcon v-else class="h-4 w-4" />
                    </span>
                </div>
            </th>
            <th scope="col" class="w-1/5 px-3 py-3.5 text-left text-sm font-semibold text-gray-900" @click="orderBy('team-members')">
                <div class="flex items-center group relative w-max cursor-pointer">
                    Mailboxes
                    <span
                        class="ml-2 flex-none rounded-sm"
                        :class="[typeOrder === 'team-members' ? 'bg-gray-100 text-gray-900 hover:bg-gray-200 p-0.5' : 'invisible text-gray-400 group-hover:visible group-focus:visible']"
                    >
                        <ChevronDownIcon v-if="asc" class="h-4 w-4" aria-hidden="true" />
                        <ChevronUpIcon v-else class="h-4 w-4" />
                    </span>
                </div>
            </th>
            <th scope="col" class="w-1/5 px-3 py-3.5 text-left text-sm font-semibold text-gray-900" @click="orderBy('created')">
                <div class="flex items-center group relative w-max cursor-pointer">
                    Date created
                    <span
                        class="ml-2 flex-none rounded-sm"
                        :class="[typeOrder === 'created' ? 'bg-gray-100 text-gray-900 hover:bg-gray-200 p-0.5' : 'invisible text-gray-400 group-hover:visible group-focus:visible']"
                    >
                        <ChevronDownIcon v-if="asc" class="h-4 w-4" aria-hidden="true" />
                        <ChevronUpIcon v-else class="h-4 w-4" />
                    </span>
                </div>
            </th>
            <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-3 rounded-r-md">
                <span class="sr-only">Edit</span>
            </th>
        </tr>
    </thead>
</template>

<style scoped></style>
